const validVehRegLastLetter = {
  A: 0, Z: 1, Y: 2, X: 3, U: 4, T: 5, S: 6, R: 7, P: 8, M: 9, L: 10, K: 11, J: 12, H: 13, G: 14, E: 15, D: 16, C: 17, B: 18
}
const vehRegLetters = {
  A: 1, B: 2, C: 3, D: 4, E: 5, F: 6, G: 7, H: 8, I: 9, J: 10, K: 11, L: 12, M: 13, N: 14, O: 15, P: 16, Q: 17, R: 18, S: 19, T: 20, U: 21, V: 22, W: 23, X: 24, Y: 25, Z: 26
}

function getMessage(field, args) {
  return `The ${field} field is invalid.`
}

function validate(value, args) {
  try {
    if (value) {
      value = value.toUpperCase()
      // Check length
      if (value.length < 3 || value.length > 8) {
        return false
      }
      // Check last letter is a valid alphabet
      const lastLetter = value[value.length - 1]
      if (!lastLetter.match(/[a-z]/i)) {
        return false
      } else {
        // Check if its valid last letter
        if (validVehRegLastLetter[lastLetter] === undefined) {
          return false
        }
      }

      // Check letter/digit sequence
      const letterSeq = []
      const numberSeq = []
      let hasCheckedLetters = false
      let hasCheckedNumbers = false
      const regNo = value.substr(0, value.length - 1)
      for (var i = 0; i < regNo.length; i++) {
        const currentLetter = regNo[i]
        if (currentLetter.match(/[a-z]/i)) {
          hasCheckedLetters = true
          if (hasCheckedNumbers) {
            // Cannot be letter - number then letter again
            return false
          } else {
            letterSeq.push(vehRegLetters[currentLetter])
          }
        } else if (currentLetter.match(/[0-9]/i)) {
          hasCheckedNumbers = true
          if (!hasCheckedLetters) {
            // letters must be before number
            return false
          } else {
            numberSeq.push(currentLetter)
          }
        } else {
          return false
        }
      }
      // Must length of numbers and letters
      if (letterSeq.length > 0 && letterSeq.length < 4 && numberSeq.length > 0 && numberSeq.length < 5) {
        const calculateArr = []
        // Letter Seq 1st slot is always 0
        letterSeq.unshift(0)
        calculateArr.push(letterSeq[letterSeq.length - 2])
        calculateArr.push(letterSeq[letterSeq.length - 1])

        // Number Seq (1st 3 is always 0)
        numberSeq.unshift(0)
        numberSeq.unshift(0)
        numberSeq.unshift(0)
        calculateArr.push(numberSeq[numberSeq.length - 4])
        calculateArr.push(numberSeq[numberSeq.length - 3])
        calculateArr.push(numberSeq[numberSeq.length - 2])
        calculateArr.push(numberSeq[numberSeq.length - 1])

        // Calculate using the formula
        let total = 0
        total = total + (parseInt(calculateArr[0]) * 9)
        total = total + (parseInt(calculateArr[1]) * 4)
        total = total + (parseInt(calculateArr[2]) * 5)
        total = total + (parseInt(calculateArr[3]) * 4)
        total = total + (parseInt(calculateArr[4]) * 3)
        total = total + (parseInt(calculateArr[5]) * 2)
        const remainder = total % 19
        if (validVehRegLastLetter[lastLetter] !== remainder) {
          return false
        }
      } else {
        return false
      }
      return true
    } else return true
  } catch (err) {
    console.log(err)
    return false
  }
}

export default {
  getMessage,
  validate
}
